import { GameName } from "./types";

export const deepLinkSchema: {
  [key in GameName]: string;
} = {
  boombeach: "boombeach-inbox",
  brawlstars: "brawlstars-inbox",
  clashofclans: "clashofclans-inbox",
  clashroyale: "clashroyale-inbox",
  hayday: "hayday-inbox",
  squadbusters: "squadbusters-inbox",
  rogue: "moco-inbox",
};
